// extracted by mini-css-extract-plugin
export default {"modalOverlay":"UJ-z","modalContent":"VJ-z","header":"WJ-z","close":"XJ-z"};